import React, { useEffect, useState, useCallback } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";

const MobiliteAutocomplete = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const fetchMobiliteData = async () => {
      setLoading(true);
      try {
        const response = await axios.get("/mobilite.xml", {
          headers: { "Content-Type": "application/xml" },
        });
        const parser = new DOMParser();
        const xml = parser.parseFromString(response.data, "application/xml");
        const mobiliteNodes = xml.getElementsByTagName("mobilite");

        const mobilites = Array.from(mobiliteNodes).map(
          (node) => node.textContent
        );
        setOptions(mobilites);
      } catch (error) {
        console.error("Error fetching mobilite data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMobiliteData();
  }, []);

  // Finalize input by adding text if not already in value and maximum not reached.
  const finalizeInput = useCallback(() => {
    const trimmedInput = inputValue.trim();
    if (trimmedInput && !value.includes(trimmedInput)) {
      if (value.length < 5) {
        onChange([...value, trimmedInput]);
      }
    }
    setInputValue("");
  }, [inputValue, value, onChange]);

  // Handle changes from Autocomplete (both selecting and typed values)
  const handleChange = (event, newValue) => {
    // Limit the selection to 5 items: slice if needed.
    if (newValue.length > 5) {
      newValue = newValue.slice(0, 5);
    }
    onChange(newValue);
  };

  return (
    <Autocomplete
      multiple
      freeSolo
      options={options}
      value={value}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onChange={handleChange}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Mobilité"
          variant="outlined"
          fullWidth
          // When the field loses focus, finalize the input.
          onBlur={finalizeInput}
          // Finalize the input when the Space key is pressed.
          onKeyDown={(e) => {
            if (e.key === " ") {
              e.preventDefault(); // Prevent space insertion.
              finalizeInput();
            }
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          sx={{
            background: "transparent",
            borderRadius: "10px",
          }}
        />
      )}
    />
  );
};

export default MobiliteAutocomplete;
